import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConversations: builder.query({
      query: () => ({
        url: API_PREFIX + "/chats/",
        method: "GET",
      }),
      providesTags: ["Chats"],
    }),
    sendMessage: builder.mutation({
      query: (details) => ({
        url: API_PREFIX + "/chats/message/send",
        method: "POST",
        body: {
          message: details.message,
          chat_uuid: details.chat_uuid,
        },
      }),
      invalidatesTags: ["Messages"],
    }),
    getAllMessages: builder.query({
      query: (chat_uuid) => ({
        url: API_PREFIX + `/chats/messages/${chat_uuid}`,
        method: "GET",
      }),
      providesTags: ["Messages"],
    }),
  }),
});

export const {
  useGetConversationsQuery,
  useLazyGetConversationsQuery,
  useSendMessageMutation,
  useGetAllMessagesQuery,
  useLazyGetAllMessagesQuery,
} = chatApiSlice;
